<div class="grid">
	<div class="col-12 mb-4" [class]="this.underTablet() ? 'flex justify-content-center' : ''">
		<form [formGroup]="siteFilters">
			<div class="grid mt-0">
				<div [class]="tabletUnderLgWidth() || onExtendedMobile() ? 'col-12 flex justify-content-center' : 'col-2 flex justify-content-start'">
					<p-button id="buttonAddSite" label="{{ 'NEW_SITE' | translate }}" icon="pi cm-plus"
						(click)="onCreateSite()" [disabled]="isImpers" [rounded]="false" [text]="true" severity="primary"
						styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
					</p-button>
				</div>
				<div [class]="tabletUnderLgWidth() || onExtendedMobile() ? 'col-12' : 'col-7'">
					<div class="flex w-full justify-content-around">
						<div class="flex align-items-center">
							<p-checkbox formControlName="ownerSites" binary="true" styleClass="mx-2"></p-checkbox>
							<p-tag value="{{ 'OWNER' | translate }}" severity="info"></p-tag>
						</div>
						<div class="flex align-items-center">
							<p-checkbox formControlName="sharedSites" binary="true" styleClass="mx-2"></p-checkbox>
							<p-tag value="{{ 'SITES_SHARED_WITH_ME' | translate }}" pTooltip="{{'LIST_DEVICE_AUTOMATIONS' | translate}} & {{'LIST_DEVICE_THERMO' | translate}}"
								styleClass="p-tag-purple" tooltipPosition="bottom">
							</p-tag>
						</div>
						<div class="flex align-items-center">
							<p-checkbox formControlName="vctSites" binary="true" styleClass="mx-2"></p-checkbox>
							<p-tag value="{{ 'VCT_SITES_SHARED' | translate }}" styleClass="p-tag-purple"></p-tag>
						</div>
					</div>
				</div>
				<div [class]="tabletUnderLgWidth() || onExtendedMobile() ? 'col-12 flex justify-content-center' : 'col-3 flex justify-content-end'">
					<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
						<i class="pi cm-search"></i>
						<input formControlName="searchFilter" pInputText type="text" [ngClass]="dynamicInputTextWidth()"
							class="pr-6 surface-900" id="site-cards-tablet-mobile-input-search" placeholder="{{ 'SEARCH' | translate }}"
							maxlength="254" />
					</span>
				</div>
				<div class="col-12">
					<div class="flex align-items-center justify-content-center">
						<p-button label="{{ 'RELOAD' | translate }}"
							icon="pi cm-reload" size="large" (click)="$event.stopPropagation(); reloadSites()"
							[rounded]="false" [text]="true" severity="secondary" styleClass="font-bold border-0">
						</p-button>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>